import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-content" }

import CustomTitleBar from "@/components/CustomTitleBar/index.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomTitleBar, { title: "收藏" }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_empty, {
        description: "暂无数据",
        image: require('@/assets/images/empty.png')
      }, null, 8, ["image"])
    ])
  ], 64))
}
}

})